import script from "./ExamEnhancementSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamEnhancementSettings.vue?vue&type=script&setup=true&lang=js"

import "./ExamEnhancementSettings.vue?vue&type=style&index=0&id=b8af477a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8af477a"]])

export default __exports__